export default __webpack_public_path__ + "static/media/post-2.70a0239d.png";